import React from 'react';
import { useSelector } from 'react-redux';
import { terminalSummarySelector } from 'slices/terminal-summary/terminalSummarySlice';
import TerminalSummaryState from 'slices/terminal-summary/TerminalSummaryState';

const TerminalDetails = ({ terminalNumber, terminalName }: { terminalNumber?: string, terminalName?: string }) => {
  const terminalSummaryState: TerminalSummaryState = useSelector(terminalSummarySelector);

  const terminalExists =
    terminalSummaryState.terminallist?.find((terminal) => {
      if (terminalNumber) {
        return terminal.terminalNumber.toString() === terminalNumber;
      }

      if (terminalName) {
        return terminal.terminalName?.toUpperCase() === terminalName.toUpperCase();
      }

      return false;
    });

  return (
    terminalExists ? <div className="driver-details__terminal-details ">
      {`${terminalExists?.airportCode} -  
      ${terminalExists?.terminalName} `}
      <span>{terminalExists?.terminalNumber}</span>
    </div> : <></>
  );
};

export default TerminalDetails;
